/* eslint-disable react-refresh/only-export-components */
import { lazy, type ReactNode } from "react";
import { Navigate, type RouteObject } from "react-router-dom";
import { dashboardPath } from "../../config/storefrontRouting";
import SuspenseWrapper from "../SuspenseWrapper";

const AdminOrdersPage = lazy(
  () => import("../../pages/commerce/AdminOrdersPage"),
);
const AdminOrderDetailsPage = lazy(
  () => import("../../pages/commerce/AdminOrderDetailsPage"),
);
const AdminCommerceOperationsPage = lazy(
  () => import("../../pages/commerce/AdminCommerceOperationsPage"),
);
const PromotionsPage = lazy(
  () => import("../../pages/commerce/PromotionsPage"),
);

const suspense = (element: ReactNode) => (
  <SuspenseWrapper>{element}</SuspenseWrapper>
);

function CommerceSettingsRedirect() {
  return <Navigate to={dashboardPath("/settings/commerce")} replace />;
}

export const commerceRoutes: RouteObject[] = [
  { path: "orders", element: suspense(<AdminOrdersPage />) },
  { path: "orders/:id", element: suspense(<AdminOrderDetailsPage />) },
  { path: "commerce/promotions", element: suspense(<PromotionsPage />) },
  {
    path: "commerce/customer-risk",
    element: suspense(<AdminCommerceOperationsPage />),
  },
  {
    path: "commerce/reviews",
    element: suspense(<AdminCommerceOperationsPage />),
  },
  {
    path: "commerce/inventory",
    element: suspense(<AdminCommerceOperationsPage />),
  },
  {
    path: "commerce/settings",
    element: <CommerceSettingsRedirect />,
  },
  {
    path: "commerce/reports",
    element: suspense(<AdminCommerceOperationsPage />),
  },
];
